<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.6917 13.7816L14.707 12.7663C15.1132 12.3601 15.1132 11.6494 14.6055 11.1417L12.6764 9.61872C12.2702 9.31412 11.7626 9.31412 11.3564 9.72025L9.93495 11.1417L7.56083 8.7676L5.25217 11.0763L8.00582 13.7816C9.52882 15.4061 12.0672 15.4061 13.6917 13.7816ZM3.82544 9.67456L6.14661 7.35339L4.85828 6.06505L6.17821 4.64358C6.58435 4.33898 6.58435 3.72977 6.27975 3.32364L4.75674 1.3945C4.35061 0.886835 3.63987 0.886835 3.23374 1.29297L2.2184 2.3083C0.593866 3.93284 0.593866 6.47118 2.2184 8.09572L3.82544 9.67456Z"
    fill="currentColor"
  />
  <rect
    x="13"
    y="2"
    width="2"
    height="17"
    rx="1"
    transform="rotate(45 13 2)"
    fill="currentColor"
  />
</template>
